module.exports = __webpack_public_path__ + "yubico_38x38.8306b1b970d5827880bf608262395984.png";